const REGISTER = {
  intro_msg: 'Request credentials for the VIACOR App.',
  success_msg: 'Request sent successfully. We will check your request and hit you up by an E-Mail.',
};

export default REGISTER;
